/**
 * Construye la URL de un cantón con prefijo de país.
 * @param {string} cantonSlug - Slug del cantón (ej. 'loja')
 * @param {Array} cantones - Lista de cantones del contexto
 * @param {string} suffix - Sufijo opcional (ej. '/registrar-arbol')
 * @returns {string} URL completa (ej. '/ec/loja' o '/ec/loja/registrar-arbol')
 */
export const buildCantonUrl = (cantonSlug, cantones, suffix = '') => {
  const canton = (cantones || []).find(c => c.slug === cantonSlug)
  const iso2 = canton?.countryIso2?.toLowerCase() || 'ec'
  return `/${iso2}/${cantonSlug}${suffix}`
}

export const buildTreePublicUrl = (cantonSlug, cantones, treeCode) => {
  if (!treeCode) return buildCantonUrl(cantonSlug, cantones)
  return buildCantonUrl(cantonSlug, cantones, `/${encodeURIComponent(treeCode)}`)
}

export const normalizePathname = pathname => {
  const normalized = `/${String(pathname || '').replace(/^\/+/, '')}`.replace(/\/+$/, '')
  return normalized || '/'
}

export const buildAbsoluteUrl = (path, baseUrl) => {
  const normalizedPath = normalizePathname(path)
  const fallbackOrigin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : ''
  const base = String(baseUrl || fallbackOrigin || '').replace(/\/+$/, '')

  return base ? `${base}${normalizedPath}` : normalizedPath
}
